<template>
  <base-nav class="navbar-dark mt-3" id="navbar-main" :show-toggle-button="false" expand></base-nav>
</template>
<script>
export default {};
</script>
